import backendStyle from '../../../../backendStyle'

export default {
  newInstance (tool) {
    return {
      createCfg (myCfg = {}, selectable = false, isPaging = true) {
        const cfg = {
          // 如果需要从接口获取数据，则此参数必传
          apiMethod: undefined,

          // 此文件内所使用的参数，你可以通过myCfg进行覆盖
          loading: true,
          data: [],
          searchs: {},
          customRow: undefined,
          selectedKeys: myCfg.selectable ? [] : undefined,
          selection: myCfg.selectable ? [] : undefined,
          showSelect: myCfg.selectable,
          emptyText: '暂无数据',
          // return的内容作为表格的data
          handleRender: res => backendStyle[process.env.VUE_APP_BACKENDER].renderList(res),
          // return的内容作为表格的请求参数
          handleRequestData: requestData => requestData

          // 其它（antd组件的参数，你可以通过myCfg传进来）
        }

        // Paging组件
        if (isPaging) {
          let pagingCfg = {
            // 此文件内所使用的参数，你可以通过myCfg.paging进行覆盖
            showPaging: false,
            pageNo: 1,
            pageSize: 10,
            pageSort: undefined,
            pageDir: undefined,
            total: 0,
            pageSizeOptions: ['10', '20', '30', '40']

            // 其它（antd组件的参数，你可以通过myCfg.paging传进来）
          }

          if (myCfg.paging) {
            pagingCfg = Object.assign(pagingCfg, myCfg.paging)
          }

          return Object.assign(cfg, myCfg, { paging: pagingCfg })
        }

        return Object.assign(cfg, myCfg)
      },
      search (cfg) {
        return new Promise((resolve) => {
          if (cfg.paging) {
            cfg.paging.pageNo = 1
          }

          this.loadData(cfg).then((res) => {
            console.log('cf', res)
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      refresh (cfg) {
        return new Promise((resolve) => {
          this.loadData(cfg).then((res) => {
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      replace (cfg) {
        return new Promise((resolve) => {
          this.loadData(cfg, true).then((res) => {
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      jump (cfg, pageNo) {
        return new Promise((resolve) => {
          if (cfg.paging) {
            cfg.paging.pageNo = pageNo
          }
          this.loadData(cfg).then((res) => {
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      resize (cfg, pageSize) {
        return new Promise((resolve) => {
          if (cfg.paging) {
            cfg.paging.pageNo = 1
            cfg.paging.pageSize = pageSize
          }
          this.loadData(cfg).then((res) => {
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      select (cfg, selectedKeys, selection) {
        cfg.selectedKeys = selectedKeys
        cfg.selection = selection
      },
      sort (cfg, meta) {
        return new Promise((resolve) => {
          const indexes = []
          for (let i = 0; i < (cfg.columns || []).length; i++) {
            if (cfg.columns[i].sortable === 'custom' && cfg.columns[i].key === meta.key) {
              indexes.push(i)
            }
          }

          if (meta.key === cfg.paging.pageSort) {
            if (cfg.paging.pageDir === undefined) {
              cfg.paging.pageDir = 'asc'
              cfg.paging.pageSort = meta.key

              for (let i = 0; i < indexes.length; i++) {
                cfg.columns[indexes[i]].sortType = 'asc'
              }
            } else if (cfg.paging.pageDir === 'asc') {
              cfg.paging.pageDir = 'desc'
              cfg.paging.pageSort = meta.key

              for (let i = 0; i < indexes.length; i++) {
                cfg.columns[indexes[i]].sortType = 'desc'
              }
            } else if (cfg.paging.pageDir === 'desc') {
              cfg.paging.pageDir = undefined
              cfg.paging.pageSort = undefined

              for (let i = 0; i < indexes.length; i++) {
                cfg.columns[indexes[i]].sortType = undefined
              }
            }
          } else {
            cfg.paging.pageDir = 'asc'
            cfg.paging.pageSort = meta.key

            for (let i = 0; i < indexes.length; i++) {
              cfg.columns[indexes[i]].sortType = 'asc'
            }
          }

          this.loadData(cfg).then((res) => {
            this.afterLoad(cfg, res).then(() => resolve(res))
          })
        })
      },
      loadData (cfg, noLoading = false) {
        return new Promise((resolve) => {
          this.beforeLoad(cfg, noLoading).then((requestData) => {
            console.log(requestData)
            cfg.apiMethod(requestData).then((res) => {
              console.log('res', res)
              resolve(res)
            })
          })
        })
      },
      beforeLoad (cfg, noLoading = false) {
        return new Promise((resolve) => {
          cfg.loading = !noLoading

          if (!noLoading) {
            cfg.selectedKeys = []
            cfg.selection = []
          }

          let requestData = {}

          if (cfg.paging) {
            backendStyle[process.env.VUE_APP_BACKENDER].joinPage(requestData, cfg.paging)

            if (cfg.paging.pageSort) requestData.sort = cfg.paging.pageSort
            if (cfg.paging.pageDir) requestData.dir = cfg.paging.pageDir
          }

          if (cfg.searchs) {
            for (const key in cfg.searchs) {
              if (cfg.searchs[key] || cfg.searchs[key] === 0 || cfg.searchs[key] === false) requestData[key] = cfg.searchs[key]
            }
          }

          requestData = cfg.handleRequestData(requestData)
          resolve(requestData)
        })
      },
      afterLoad (cfg, res) {
        return new Promise((resolve) => {
          tool.wrapResponse(res).then(() => {
            cfg.emptyText = '暂无数据'
            if (cfg.paging) {
              cfg.paging.total = backendStyle[process.env.VUE_APP_BACKENDER].renderTotal(res)
              cfg.paging.showPaging = true
            }

            cfg.data = cfg.handleRender(res)

            resolve(res)
          }).catch(() => {
            cfg.emptyText = tool.getResponseError(res)
            cfg.data = []
          })
          cfg.loading = false
        })
      }
    }
  }
}
